import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminDashboard from './adminDashboard';
import CreateBlog from './createBlog';
import ProviderList from './providerList';
import RequesterList from './requesterList';
import UserRequestList from './userRequestList';
import CreateWarehouse from './createWarehouse';
import Sidebar from '../components/sidebar'; // Import Sidebar
import WarehouseList from './warehouseList';
import CommonEnquiries from './commonEnquiryList';
import UserManagement from './userManagement';
import UserTable from './userTable';
import AdminTable from './adminTable';
import ClientTable from './clientTable';
import MarketerTableList from './marketerTable';

// AdminLayout to display Sidebar and content
function AdminRoutes() {
    return (
        <div className='container-fluid'>
            <div className='row'>
                {/* Sidebar - 2 columns */}
                <div className='col-2 p-0'>
                    <Sidebar /> {/* Sidebar is always shown on admin routes */}
                </div>

                {/* Main content area - 10 columns */}
                <div className='col-10 admin-content pt-5'>
                    <Routes>
                        <Route path='/' element={<AdminDashboard />} />
                        <Route path='/requesterList' element={<RequesterList />} />
                        <Route path='/userRequestList' element={<UserRequestList />} />
                        <Route path='/providerList' element={<ProviderList />} />
                        <Route path='/commonEnquiryList' element={<CommonEnquiries />} />
                        <Route path='/createBlog' element={<CreateBlog />} />
                        <Route path='/createWarehouse' element={<CreateWarehouse />} />
                        <Route path='/warehouseList' element={<WarehouseList />} />
                        <Route path='/userManagement/*' element={<UserManagement />} >
                            <Route path="users" element={<UserTable />} />
                            <Route path='admin' element={<AdminTable />} />
                            <Route path='clients' element={<ClientTable />} />
                            <Route path='marketers' element={<MarketerTableList />} />
                        </Route>
                    </Routes>
                </div>
            </div>
        </div>

    );
}

export default AdminRoutes;
